import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../index'

type UserOptionsState = {
  locale: string
  darkTheme: boolean
  sidebarOpen: boolean
}

const initialState: UserOptionsState = {
  locale: 'en',
  darkTheme: false,
  sidebarOpen: true,
}

const userOptionsSlice = createSlice({
  name: 'userOptions',
  initialState: initialState,
  reducers: {
    updateLocale: (state, action: PayloadAction<string>) => {
      state.locale = action.payload
    },
    toggleTheme: (state) => {
      state.darkTheme = !state.darkTheme
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen
    },
  },
})

export const userOptionsReducer = userOptionsSlice.reducer
export const userOptionsActions = userOptionsSlice.actions

const selectSlice = (state: RootState) => state.userOptions

export const localeSelector = createSelector(selectSlice, (userOptionsState) => userOptionsState.locale)
export const isDarkThemeSelector = createSelector(selectSlice, (userOptionsState) => userOptionsState.darkTheme)
export const isSidebarOpenSelector = createSelector(selectSlice, (userOptionsState) => userOptionsState.sidebarOpen)
